/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
import React from 'react';
import { http } from '@/helpers/index';
import SalesCommunication from '@/components/site/sales-communication';
import Seo from '@/components/seo';
import { auth } from '@/services/auth';

function CommunicationSite({ warning, product }) {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://aboutcar.com.br/'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Comunicação de Venda',
        item: 'https://aboutcar.com.br/comunicacao-venda'
      }
    ]
  };

  return (
    <>
      <Seo
        title="Comunicação de Venda de Veículo Online | AboutCar"
        description="Comunique a venda do seu veículo de forma 100% online na AboutCar. Evite multas, débitos e responsabilidade civil ou criminal após a venda do seu automóvel."
        keywords="comunicação de venda, comunicar venda detran, aviso de venda carro, comunicação de venda online, transferencia de veiculo"
        schema={breadcrumbSchema}
      />
      <SalesCommunication options={{ warning, product }} />
    </>
  );
}

CommunicationSite.enableMessages = true;
export default CommunicationSite;

export async function getServerSideProps(context) {
  const res = await http.baseAsync('GET', '/configurations');
  let warning = '';
  if (res.ok) {
    const item = await res.json();
    if (item && !item.vendors.checktudo.online) {
      warning = item.vendors.message;
    }
  }

  const resProduct = await http.baseAsync('GET', '/products/comunicacao-venda', null, false, auth.headers());
  const product = await resProduct.json();

  return { props: { warning, product, }, };
}
